<template>
  <div class="container download-page">
    <div
      class="top-wrapper brand-bg-color"
      :style="navBgStyle"
    >
      <div
        class="left-over"
        :style="navLeftBgStyle"
        v-if="navInfo.backgroundImg.left.fileId !== '-1'"
      ></div>
      <div
        class="right-over"
        :style="navRightBgStyle"
        v-if="navInfo.backgroundImg.right.fileId !== '-1'"
      ></div>
      <div class="systemInfo">
        <img
          class="icon"
          :src="logoPath"
          v-if="themeInfo.systemLogoInfo"
        />
        <img
          class="font-img"
          :src="fontPath"
          v-if="!themeInfo.fontType"
          :style="fontImgStyle"
        />
        <span
          class="system-name"
          v-else
        >{{ themeInfo.systemName }}</span>
        <div class="divider"></div>
        <span class="type-name">{{ typeName }}</span>
      </div>
    </div>
    <div class="bottom-wrapper">
      <el-scrollbar class="auto-height-scrollbar">
        <div class="content">
          <div
            v-for="(group, index) in tableData"
            :key="index"
          >
            <h3
              :key="index"
              class="title"
            >{{ group.name }}</h3>

            <div class="m-atta-outer">
              <attachment-info
                v-for="file in group.fileList"
                :icon="file.icon"
                :name="file.name"
                :desc="file.desc"
                :qrcode="file.qrCode"
                :key="file.code"
                :path="file.filePath"
                :size="file.size"
              >
              </attachment-info>
              <attachment-info
                v-for="sub in group.children"
                :icon="sub.icon"
                :name="sub.name"
                :desc="sub.desc"
                :key="sub.code"
              >
                <template v-for="item in sub.fileList">
                  <subitem-info
                    :path="item.filePath"
                    v-if="item.qrCode"
                    :key="item.code"
                    :name="item.name"
                    :size="item.size"
                  >
                  </subitem-info>
                </template>

              </attachment-info>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>
    <need-modify-pwd></need-modify-pwd>
  </div>
</template>

<script>
import Api from 'api/api'
import needModifyPwd from 'components/need-modify-pwd/need-modify-pwd'
import attachmentInfo from './attachment-info.vue'
import subitemInfo from './subitem-info.vue'
import { ErrorHandleMixin, LoadingMixin } from 'utils/mixin'
export default {
  name: 'download-page',
  data () {
    return {
      navInfo: {
        backgroundImg: {
          left: { fileId: '-1' },
          middle: { fileId: '-1' },
          right: { fileId: '-1' }
        }
      },
      themeInfo: {},
      tableData: []
    }
  },
  computed: {
    typeName () {
      if (this.$route.params.type === 'attachment') return this.$t('download.type_name1')
      else return this.$t('download.type_name2')
    },
    navBgStyle () {
      // if (this.navInfo.backgroundImg.middle.fileId !== '-1') {
      //   return {
      //     'background-image': `url(${this.navInfo.backgroundImg.middle.path})`
      //   }
      // } else {
      //   return {}
      // }
      return this.handleNavStyle('middle')
    },
    navLeftBgStyle () {
      // if (this.navInfo.backgroundImg.left.fileId !== '-1') {
      //   return {
      //     width: `${this.navInfo.backgroundImg.left.width}px`,
      //     'background-image': `url(${this.navInfo.backgroundImg.left.path})`
      //   }
      // } else {
      //   return {}
      // }
      return this.handleNavStyle('left')
    },
    navRightBgStyle () {
      // if (this.navInfo.backgroundImg.right.fileId !== '-1') {
      //   return {
      //     width: `${this.navInfo.backgroundImg.right.width}px`,
      //     'background-image': `url(${this.navInfo.backgroundImg.right.path})`
      //   }
      // } else {
      //   return {}
      // }
      return this.handleNavStyle('right')
    },
    logoPath () {
      return this.themeInfo.systemLogoInfo ? this.themeInfo.systemLogoInfo.path : ''
    },
    fontPath () {
      return this.themeInfo.fontImgInfo ? this.themeInfo.fontImgInfo.path : ''
    },
    fontImgStyle () {
      const _fontImg = this.themeInfo.fontImgInfo
      if (!_fontImg) return {}
      const _height = parseInt(_fontImg.height) < 24 ? _fontImg.height : 24
      return {
        height: `${_height}px`
      }
    },
    iconImgStyle () {
      const _iconImg = this.themeInfo.systemLogoInfo
      if (!_iconImg) return {}
      const _height = parseInt(_iconImg.height) < 24 ? _iconImg.height : 24
      return {
        height: `${_height}px`
      }
    }
  },
  filters: {
    fixedTwo (value) {
      return `${value.toFixed(2)} M`
    }
  },
  methods: {
    handleNavStyle (pos) {
      if (this.navInfo.backgroundImg[pos].fileId !== '-1') {
        return {
          width: `${this.navInfo.backgroundImg[pos].width}px`,
          'background-image': `url(${this.navInfo.backgroundImg[pos].path})`
        }
      } else {
        return {}
      }
    },
    _getNavInfo () {
      Api.navigate.query().then(res => {
        this.navInfo = res.data
      })
    },
    _getThemeInfo () {
      Api.theme.query().then(res => {
        this.themeInfo = res.data
      })
    },
    _getAttachmentData () {
      let _loadingInstance = this._getLoading()
      Api.common.getDownloadAttachmentGroup({ language: this.$storage.get('portal_language') }).then(res => {
        _loadingInstance.close()
        this.tableData = res.data.list || []
      }).catch(() => {
        _loadingInstance.close()
      })
    },
    _getTableData () {
      this._getAttachmentData()
    },
    download (data) {
      window.open(data.filePath)
    }
  },
  mounted () {
    this._getNavInfo()
    this._getThemeInfo()
    this._getTableData()
  },
  mixins: [ErrorHandleMixin, LoadingMixin],
  components: {
    needModifyPwd,
    attachmentInfo,
    subitemInfo
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.download-page.container {
  width: 100%;
  height: 100%;
  position: relative;
  .top-wrapper {
    height: 36px;
    background-repeat: repeat-x;
    position: relative;
    color: #fff;
    .left-over {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
    }
    .right-over {
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
    }
    .systemInfo {
      width: 100%;
      height: 100%;
      position: relative;
      z-index: 99;
      box-sizing: border-box;
      .icon {
        width: 32px;
        height: 32px;
        float: left;
        margin: 2px 12px;
      }
      .font-img {
        height: 100%;
        width: auto;
        display: inline-block;
        vertical-align: middle;
      }
      .system-name {
        display: block;
        float: left;
        line-height: 36px;
      }
      .divider {
        width: 1px;
        height: 18px;
        float: left;
        margin: 9px 12px;
      }
      .type-name {
        display: block;
        float: left;
        line-height: 36px;
      }
    }
  }
  .bottom-wrapper {
    position: absolute;
    left: 0;
    right: 0;
    top: 36px;
    bottom: 0;
    background-color: #f5f5f5;
    overflow: auto;
    .content {
      width: 1200px;
      margin: 56px auto 0;
      font-size: 0;
      .m-atta-outer {
        .attachment-info:nth-child(3n) {
          margin-right: 0;
        }
      }
      .title {
        font-size: 14px;
        color: #878787;
        font-weight: normal;
        margin: 0 0 24px;
      }
    }
  }
}
</style>
